module.exports = __webpack_public_path__ + "media/icons/check-done-1e0ba33e.png";